export const ItemTypes = {
  ACTOR: "actor",
  CHARACTER: "character"
};
